var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "FRANCE_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_48342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000052075520839905957340000009611318546611897004_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.0688 0.385742H0.505859V19.9637H34.0688V0.385742Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_48342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6938 0.385742H0.505859V19.9637H11.6938V0.385742Z",
    fill: "#323E95"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_48342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000052075520839905957340000009611318546611897004__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0688 0.385742H0.505859V19.9637H34.0688V0.385742Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_48342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.8804 0.385742H11.6924V19.9637H22.8804V0.385742Z",
    fill: "#F4F4F4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_48342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000052075520839905957340000009611318546611897004__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.0688 0.385742H0.505859V19.9637H34.0688V0.385742Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_48342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.0688 0.385742H22.8809V19.9637H34.0688V0.385742Z",
    fill: "#D80031"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/FRANCE.1df9f6442037e1a821ee0c44ba743985.svg";
export { ForwardRef as ReactComponent };